import Localization from './Localization'

export default Localization
